import React from 'react';
import { CheckCircleIcon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline';

export default function NotificationToast({ type = "success", message, onClose }) {
  if (!message) return null;

  const isSuccess = type === "success";

  return (
    <div
      className={`fixed bottom-8 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-3 w-max max-w-[90vw] p-4 rounded-xl shadow-2xl font-medium animate-slide-up border transition-all duration-300 ${
        isSuccess
          ? 'bg-emerald-50 border-emerald-200 text-emerald-800'
          : 'bg-red-50 border-red-200 text-red-800'
      }`}
    >
      {isSuccess ? (
        <CheckCircleIcon className="w-6 h-6 flex-shrink-0 text-emerald-600" aria-hidden="true" />
      ) : (
        <ExclamationTriangleIcon className="w-6 h-6 flex-shrink-0 text-red-600" aria-hidden="true" />
      )}

      <div className="text-sm">
        <strong>{isSuccess ? 'Succès ! ' : 'Erreur : '}</strong>
        {message}
      </div>

      <button
        type="button"
        onClick={onClose}
        className="ml-2 p-1 opacity-70 hover:opacity-100 transition-opacity"
        aria-label="Fermer la notification"
      >
        <XMarkIcon className="w-5 h-5 text-current" aria-hidden="true" />
      </button>
    </div>
  );
}
